<template>
    <a href="#" @click.prevent="showModal" target="_blank" class="button blue">
        <span class="icon"><i class="mdi mdi-plus"></i></span>
        <span>Assign Influencer(s)</span>
    </a>

    <modal v-show="isModalVisible"
           @close="closeModal" :is-active="isModalVisible">
        <template v-slot:header>Assign Influencer to campaign</template>
        <template v-slot:body>
            <table>
                <tbody>
                <tr v-for="referrer in referrers" :key="referrer.id">
                    <td data-label="Name">{{ referrer.name }}</td>
                    <td class="actions-cell">
                        <div class="buttons right nowrap">
                            <button v-if="canAddReferrerToCampaignForPlan(assignedReferrersCount)" class="button small"
                                    :class="{'green':canAddReferrerToCampaignForPlan(assignedReferrersCount),'light':!canAddReferrerToCampaignForPlan(assignedReferrersCount)}"
                                    type="button" @click="assignReferrer(referrer.id)"
                                    :disabled="!canAddReferrerToCampaignForPlan(assignedReferrersCount)">
                                Assign
                            </button>
                            <small class="button small red" v-else>Account maximum reached</small>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </template>
        <template v-slot:footer>
            <new-referrer></new-referrer>
            <a href="#" @click.prevent="getReferrers" target="_blank" class="button green">
                <span class="icon"><i class="mdi mdi-reload"></i></span>
                <span>Refresh</span>
            </a>
        </template>
    </modal>
</template>

<script>
import {Inertia} from '@inertiajs/inertia';
import Modal from "@/Components/Modal";
import NewReferrer from "@/Components/NewReferrer";
import Button from "@/Jetstream/Button";

export default {
    name: "AssignReferrer",
    components: {Button, NewReferrer, Modal},
    props: {
        campaign: String,
        referrersCount: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            isModalVisible: false,
            referrers: {},
            assignedReferrersCount : this.referrersCount
        }
    },
    methods: {
        showModal() {
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        },
        getReferrers() {
            axios.get('/sanctum/csrf-cookie').then(response => {
                axios.get(route('referrers.list', {'campaign': this.campaign}))
                    .then((response) => {
                        this.referrers = response.data.referrers
                    });
            });
        },
        assignReferrer(referrerID) {
            axios.get('/sanctum/csrf-cookie').then(response => {
                axios.post(route('campaigns.assign-referrer', {
                    'campaign': this.campaign,
                    'referrer': referrerID
                })).then((response) => {
                    this.$toast.show('Assigned Referrer!');
                    this.referrers = this.referrers.filter(referrer => referrer.id !== referrerID);
                    this.assignedReferrersCount++ ;//add to the referrers count to monitor if more can be added based on package
                    Inertia.reload();
                }).catch(error => {
                    console.log(error.response)
                });
            });
        }
    },
    created() {
        this.getReferrers();
    },
    activated() {
        this.getReferrers();
    }
}
</script>

<style scoped>

</style>
